import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=8686f5a0&scoped=true&"
import script from "./MobileHeader.vue?vue&type=script&lang=ts&"
export * from "./MobileHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=8686f5a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8686f5a0",
  null
  
)

export default component.exports